import { server_connection } from 'config';

import {auth} from 'firebase-db';
import * as UserActions from 'auth/store/actions';
import {LOGIN_ERROR} from 'auth/store/actions/login.actions';
import {LOGIN_SUCCESS} from 'auth/store/actions/login.actions';
import * as Actions from 'store/actions';
import history from 'history.js';

export const REGISTER_ERROR = 'REGISTER_ERROR';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const CHECK_SESSION_KEY = 'CHECK_SESSION_KEY';


export function registerUser(model) {
    return (dispatch, getState) => {
        fetch(server_connection + '/auth/register',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(model)
            })
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.SUCCESS) {
                    dispatch(UserActions.setUserData(responseData.data));

                    return dispatch({
                        type: REGISTER_SUCCESS,
                    });
                } else {
                    return dispatch({
                        type: REGISTER_ERROR,
                        payload: responseData.error
                    });
                }
            });
    }
}

export function sendPasswordResetEmail(emailAddress) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/auth/get-user-by-email/' + emailAddress)
    }
}

export function registerWithFirebase(model)
{
    const {email, password, displayName} = model;
    return (dispatch) =>
        auth.createUserWithEmailAndPassword(email, password)
            .then(response => {

                dispatch(UserActions.createUserSettings({
                    ...response.user,
                    displayName,
                    email
                }));

                return dispatch({
                    type: REGISTER_SUCCESS
                });
            })
            .catch(error => {
                const usernameErrorCodes = [
                    'auth/operation-not-allowed',
                    'auth/user-not-found',
                    'auth/user-disabled'
                ];

                const emailErrorCodes = [
                    'auth/email-already-in-use',
                    'auth/invalid-email',
                ];

                const passwordErrorCodes = [
                    'auth/weak-password',
                    'auth/wrong-password'
                ];

                const response = {
                    email: emailErrorCodes.includes(error.code) ? error.message : null,
                    displayName: usernameErrorCodes.includes(error.code) ? error.message : null,
                    password: passwordErrorCodes.includes(error.code) ? error.message : null
                };

                if ( error.code === 'auth/invalid-api-key' )
                {
                    dispatch(Actions.showMessage({message: error.message}));
                }

                return dispatch({
                    type   : LOGIN_ERROR,
                    payload: response
                });
            });
}

export function checkSessionKey(sessionKey) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/auth/portal_login',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ sessionKey })
            })
            .then((response) => response.json())
            .then((responseData) => {
                console.log(responseData)
                if(responseData.SUCCESS) {
                    dispatch(UserActions.setUserData(responseData.data));

                    if (responseData.data.Verified === 0) {
                        dispatch({
                            type: LOGIN_SUCCESS,
                        });
                        return history.push('/password_verify');
                    }

                    else {
                        dispatch({
                            type: LOGIN_SUCCESS,
                        });
                        return history.push('/dashboard');
                    }

                } else {
                    return dispatch({
                        type: LOGIN_ERROR,
                        payload: responseData.error
                    });
                }
            });
    }
}



// WEBPACK FOOTER //
// src/auth/store/actions/register.actions.js